var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCommunity = function SvgCommunity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#F6F8FB",
    width: 48,
    height: 48,
    rx: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 9h30v30H9z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.5 11.5)",
    strokeWidth: 2.4
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#696F7F",
    cx: 12.5,
    cy: 12.5,
    r: 12.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.868 10.342 6.172-2.645a.2.2 0 0 1 .263.263l-2.645 6.172a1 1 0 0 1-.526.526L7.96 17.303a.2.2 0 0 1-.263-.263l2.645-6.172a1 1 0 0 1 .526-.526Z",
    stroke: "#686F81"
  })))));
};
export default SvgCommunity;